module.exports = __webpack_public_path__ + "static/media/help1.cbf52a5c.jpg";